export default "__VITE_ASSET__CtxgDVYk__"